import { NavBar } from '../nav-bar';
import { LayoutHeaderProps } from './types';

export const LayoutHeader: React.FC<LayoutHeaderProps> = () => {
  return <NavBar />;
};
